export default function TravelogueFeature() {
  return (
    <section className="relative bg-[#FFFBF4] px-6 lg:px-20 py-24 overflow-hidden">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-20 items-center">
        {/* Left Visual Composition */}
        <div className="relative w-full h-[420px] sm:h-[550px]">
          {/* Sprinkle / dash pattern */}
          <img
            src="/bg11.png"
            alt="Decorative Sprinkle/Dash Pattern"
            className="absolute -left-10 top-10 w-40 h-40 rotate-12 scale-[1.5]"
          />

          {/* Main Book Cover */}
          <img
            src="/book1.jpeg"
            alt="When the Rain Paused cover"
            className="absolute top-0 left-24 w-52 sm:w-80  object-contain rounded shadow-xl bg-[#e9e7e3]"
            style={{ objectFit: "cover" }}
          />

          {/* Secondary Book Cover */}
          <img
            src="/book2.jpeg"
            alt="When the Shadows Spoke cover"
            className="absolute bottom-0 left-0 w-56  sm:w-64  object-contain rounded shadow-lg bg-[#dfdfdf]"
            style={{ objectFit: "cover" }}
          />

          {/* Handwritten text placeholder */}
          <img
            src="/bg33.png"
            alt="Bon voyage handwritten"
            className="absolute bottom-6 left-32 md:left-56 w-44 h-auto"
          />
        </div>

        {/* Right Content */}
        <div className="relative z-10 max-w-xl">
          <p className="text-xs tracking-[0.35em] text-[#565449] mb-4">
            FEATURED NOVELS
          </p>
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl text-[#11120D] mb-7">
            Sweta Singh: Stories of Love & Shadows
          </h2>
          <div className="space-y-8 text-[#565449] leading-relaxed mb-2">
          <div>
              <h3 className="font-serif text-xl text-[#11120D] mb-1">When the Shadows Spoke</h3>
              <p className="mb-1 italic text-sm text-[#867e68]">A haunting thriller about erased pasts, hidden power, and the cost of remembering.</p>
              <p>
                Crime Branch officer Arjun uncovers missing records and rewritten lives. As he and Reema uncover dangerous secrets, they realize some histories are kept hidden for a reason. Atmospheric and gripping, this novel quietly explores what is lost—and what it costs—to bring the truth into the light.
              </p>
            </div>
            <div>
              <h3 className="font-serif text-xl text-[#11120D] mb-1">When the Rain Paused</h3>
              <p className="mb-1 italic text-sm text-[#867e68]">A love story that grows in silence, survives storms, and finds hope in the middle of chaos.</p>
              <p>
                In rain-washed Mumbai, Aanya and Rivan’s chance meeting becomes an intense and healing love. But secrets from the past threaten their bond—forcing them to fight for each other when everything seems lost. Tender, moving, and beautifully written, this is a romance about courage, longing, and the quiet moments that change everything.
              </p>
            </div>
           
          </div>
          {/* Paper plane illustration placeholder */}
          <div className="hidden lg:block absolute -bottom-16 right-0 opacity-70">
            {/* svg illustration here */}
          </div>
        </div>
      </div>
    </section>
  );
}